export const StaticValues = {
  PAYMENT_IN_PROGRESS: 'Payment verification in progress',
};
